module.exports = __webpack_public_path__ + "img/fondo-app.28e036d7.jpg";